import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.span`
  ${({ displayState }) => css`
    position: relative;
    width: ${displayState?.width ?? ''};
    height: ${displayState?.height ?? ''};
    span {
      display: none;
    }
    &:hover {
      span {
        display: unset;
      }
    }
  `}
`;

export default Wrapper(template)